import SyncContainer from './containers/SyncContainer';

export default SyncContainer;